"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var utils_1 = require("./utils");
function useFileUploader(_a) {
    var _this = this;
    var getUploadParams = _a.getUploadParams, onUploaded = _a.onUploaded, onFailed = _a.onFailed;
    var _b = react_1.useState([]), fileBags = _b[0], setFileBags = _b[1];
    var _c = react_1.useState([]), newFileBags = _c[0], setNewFileBags = _c[1];
    var findFileBagIndexById = react_1.useCallback(function (id) {
        var index = -1;
        for (var i = 0; i < fileBags.length; i++) {
            if (fileBags[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }, [fileBags]);
    var updateFileBag = react_1.useCallback(function (id, data) { return __awaiter(_this, void 0, void 0, function () {
        var _a, updatedFileBag, fileBags;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) {
                        setFileBags(function (prevFileBags) {
                            var index = findFileBagIndexById(id);
                            if (index < 0) {
                                return prevFileBags;
                            }
                            prevFileBags[index] = __assign(__assign({}, prevFileBags[index]), data);
                            var updatedFileBag = prevFileBags[index];
                            var nextFileBags = __spreadArrays(prevFileBags);
                            resolve({ updatedFileBag: updatedFileBag, fileBags: nextFileBags });
                            return nextFileBags;
                        });
                    })];
                case 1:
                    _a = _b.sent(), updatedFileBag = _a.updatedFileBag, fileBags = _a.fileBags;
                    return [2 /*return*/, { updatedFileBag: updatedFileBag, fileBags: fileBags }];
            }
        });
    }); }, [setFileBags, findFileBagIndexById]);
    var uploadFile = react_1.useCallback(function (file, id) { return __awaiter(_this, void 0, void 0, function () {
        var defaultConfig, _a, url, method, headers, data, meta, res, status_1, _b, updatedFileBag, fileBags_1, uploadedFileBags, e_1, status_2, _c, updatedFileBag, fileBags_2, failedFileBags;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    defaultConfig = {
                        onUploadProgress: function (_a) {
                            var total = _a.total, loaded = _a.loaded;
                            var progress = Math.round((loaded / total) * 100);
                            var status = 'uploading';
                            updateFileBag(id, { progress: progress, status: status });
                        },
                        data: file,
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 5, , 7]);
                    return [4 /*yield*/, getUploadParams(file)];
                case 2:
                    _a = _d.sent(), url = _a.url, method = _a.method, headers = _a.headers, data = _a.data, meta = _a.meta;
                    return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, defaultConfig), { url: url, method: method, headers: headers, data: data }))];
                case 3:
                    res = _d.sent();
                    status_1 = 'uploaded';
                    return [4 /*yield*/, updateFileBag(id, {
                            responseData: res.data,
                            status: status_1,
                            httpStatus: res.status,
                            meta: meta,
                        })];
                case 4:
                    _b = _d.sent(), updatedFileBag = _b.updatedFileBag, fileBags_1 = _b.fileBags;
                    if (updatedFileBag && onUploaded) {
                        uploadedFileBags = fileBags_1.filter(function (_a) {
                            var status = _a.status;
                            return status === 'uploaded';
                        });
                        onUploaded(updatedFileBag, uploadedFileBags);
                    }
                    return [3 /*break*/, 7];
                case 5:
                    e_1 = _d.sent();
                    status_2 = 'failed';
                    return [4 /*yield*/, updateFileBag(id, {
                            status: status_2,
                            httpStatus: e_1 && e_1.response && e_1.response.status,
                            responseData: e_1 && e_1.response && e_1.response.data,
                        })];
                case 6:
                    _c = _d.sent(), updatedFileBag = _c.updatedFileBag, fileBags_2 = _c.fileBags;
                    if (updatedFileBag && onFailed) {
                        failedFileBags = fileBags_2.filter(function (_a) {
                            var status = _a.status;
                            return status === 'failed';
                        });
                        onFailed(updatedFileBag, failedFileBags);
                    }
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [getUploadParams, onUploaded, updateFileBag]);
    var retryUpload = react_1.useCallback(function (id) { return __awaiter(_this, void 0, void 0, function () {
        var updatedFileBag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateFileBag(id, {
                        httpStatus: null,
                        responseData: null,
                    })];
                case 1:
                    updatedFileBag = (_a.sent()).updatedFileBag;
                    if (updatedFileBag) {
                        uploadFile(updatedFileBag.file, id);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [fileBags, findFileBagIndexById, uploadFile]);
    var onDrop = react_1.useCallback(function (acceptedFiles) {
        // return if null or undefined
        if (!acceptedFiles) {
            return;
        }
        acceptedFiles = __spreadArrays(acceptedFiles); // converts to array if FileList
        var arr = acceptedFiles.map(function (file) {
            var timeStamp = new Date().getTime();
            return {
                id: timeStamp + file.name,
                file: file,
                progress: 0,
                status: 'uploading',
                formattedSize: utils_1.formatFileSize(file.size),
            };
        });
        setFileBags(__spreadArrays(fileBags, arr));
        setNewFileBags(arr);
    }, [fileBags, setFileBags]);
    react_1.useEffect(function () {
        // trigger upload whenever a new file is added
        newFileBags.map(function (_a) {
            var file = _a.file, id = _a.id;
            return uploadFile(file, id);
        });
        // adding uploadFile to list of dependencies will cause infinity loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newFileBags]);
    var removeFileBag = react_1.useCallback(function (id) {
        var index = findFileBagIndexById(id);
        fileBags.splice(index, 1);
        setFileBags(__spreadArrays(fileBags));
    }, [fileBags, setFileBags, findFileBagIndexById]);
    var clearFileBags = react_1.useCallback(function () {
        setFileBags([]);
    }, [setFileBags]);
    return {
        onDrop: onDrop,
        fileBags: fileBags,
        retryUpload: retryUpload,
        removeFileBag: removeFileBag,
        clearFileBags: clearFileBags,
    };
}
exports.default = useFileUploader;
__export(require("./utils"));
